export default {
  content: {
    title: 'Thank you!',
    description: 'You’ve made your good deed of the day by making {{firstName}} happy',
  },
  joinCommunity: 'Why not join the community?',
  downloadButton: 'Download SOSAFE',
  contactAgain: 'Contact {{firstName}} again',
};
